import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % 4);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="bg-gradient-to-br from-slate-50 via-stone-50 to-amber-50 min-h-screen">
      {" "}
      {/* Navbar */}
      <nav className="bg-white/95 backdrop-blur-md shadow-lg sticky top-0 z-50 border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex-shrink-0">
              <Link
                to="/"
                className="text-3xl font-bold bg-gradient-to-r from-slate-800 via-amber-600 to-stone-700 bg-clip-text text-transparent"
              >
                📄 Letterly
              </Link>
            </div>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center space-x-8">
              <a
                href="#features"
                className="text-slate-600 hover:text-amber-600 transition-colors duration-300 font-medium"
              >
                Features
              </a>
              <a
                href="#how-it-works"
                className="text-slate-600 hover:text-amber-600 transition-colors duration-300 font-medium"
              >
                How It Works
              </a>
              <a
                href="#industries"
                className="text-slate-600 hover:text-amber-600 transition-colors duration-300 font-medium"
              >
                Industries
              </a>
              <a
                href="#founder"
                className="text-slate-600 hover:text-amber-600 transition-colors duration-300 font-medium"
              >
                About
              </a>
              <a
                href="#contact"
                className="text-slate-600 hover:text-amber-600 transition-colors duration-300 font-medium"
              >
                Contact
              </a>
            </div>

            {/* Right side buttons */}
            <div className="flex items-center space-x-4">
              <Link
                to="/login"
                className="text-slate-600 hover:text-amber-600 transition-colors duration-300 font-medium hidden sm:block"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                className="bg-gradient-to-r from-slate-800 to-amber-600 text-white px-6 py-2.5 rounded-full hover:from-slate-900 hover:to-amber-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl font-medium"
              >
                Get Started Free
              </Link>

              {/* Mobile menu button */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="lg:hidden inline-flex items-center justify-center p-2 rounded-md text-slate-600 hover:text-amber-600 hover:bg-stone-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-amber-500"
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={
                      mobileMenuOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="lg:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1 border-t border-stone-200 bg-white/95 backdrop-blur-md">
                <a
                  href="#features"
                  className="block px-3 py-2 text-slate-600 hover:text-amber-600 font-medium transition-colors duration-300"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Features
                </a>
                <a
                  href="#how-it-works"
                  className="block px-3 py-2 text-slate-600 hover:text-amber-600 font-medium transition-colors duration-300"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  How It Works
                </a>
                <a
                  href="#industries"
                  className="block px-3 py-2 text-slate-600 hover:text-amber-600 font-medium transition-colors duration-300"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Industries
                </a>
                <a
                  href="#founder"
                  className="block px-3 py-2 text-slate-600 hover:text-amber-600 font-medium transition-colors duration-300"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  About
                </a>
                <a
                  href="#contact"
                  className="block px-3 py-2 text-slate-600 hover:text-amber-600 font-medium transition-colors duration-300"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact
                </a>
                <Link
                  to="/login"
                  className="block px-3 py-2 text-slate-600 hover:text-amber-600 font-medium transition-colors duration-300"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Sign In
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
      {/* Hero Section */}
      <main className="relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-amber-300/15 to-stone-400/15 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-slate-400/15 to-amber-300/15 rounded-full translate-x-1/2 translate-y-1/2 animate-pulse delay-1000"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6 text-center lg:pt-15">
          {" "}
          <div
            className={`transition-all duration-1000 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            {" "}
            <h1 className="mx-auto max-w-4xl font-display text-5xl font-medium tracking-tight text-slate-900 sm:text-7xl">
              Generate{" "}
              <span className="relative whitespace-nowrap text-transparent bg-clip-text bg-gradient-to-r from-slate-800 via-amber-600 to-stone-700">
                <svg
                  aria-hidden="true"
                  viewBox="0 0 418 42"
                  className="absolute top-2/3 left-0 h-[0.58em] w-full fill-amber-300/60"
                  preserveAspectRatio="none"
                >
                  <path d="m203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z" />
                </svg>
                <span className="relative text-slate-900">Data Into Impact</span>
              </span>{" "}
              Professional PDFs at Enterprise Scale
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg tracking-tight text-slate-700">
              The enterprise PDF generation platform that transforms your CSV
              data into beautifully designed, personalized documents. From
              customer communications to compliance reports—generate thousands
              of professional PDFs in minutes with drag-and-drop simplicity.
            </p>
            <div className="mt-10 flex justify-center gap-x-6">
              <Link
                to="/register"
                className="group inline-flex items-center justify-center rounded-full py-3 px-8 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-gradient-to-r from-slate-800 to-amber-600 text-white hover:from-slate-900 hover:to-amber-700 transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl"
              >
                Start Free Trial
                <svg
                  className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </Link>
              <a
                href="#how-it-works"
                className="group inline-flex ring-1 items-center justify-center rounded-full py-3 px-8 text-sm focus:outline-none ring-stone-300 text-slate-700 hover:text-slate-900 hover:ring-amber-400 transition-all duration-300"
              >
                <svg
                  className="h-3 w-3 flex-none fill-amber-600 group-active:fill-current mr-2"
                  viewBox="0 0 24 24"
                >
                  <polygon points="5,3 19,12 5,21"></polygon>
                </svg>
                Watch Demo
              </a>
            </div>
          </div>
        </div>{" "}
        {/* Stats Section */}
        <div className="bg-white/60 backdrop-blur-sm border-y border-stone-200 py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
              <div className="text-center">
                <div className="text-3xl font-bold text-slate-800">1M+</div>
                <div className="text-sm font-medium text-slate-600 mt-1">
                  Documents Generated
                </div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-amber-600">500+</div>
                <div className="text-sm font-medium text-slate-600 mt-1">
                  Enterprise Customers
                </div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-stone-700">99.9%</div>
                <div className="text-sm font-medium text-slate-600 mt-1">
                  Uptime SLA
                </div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-slate-800">SOC 2</div>
                <div className="text-sm font-medium text-slate-600 mt-1">
                  Compliance
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>{" "}
      {/* Features Section */}
      <div
        id="features"
        className="py-14 bg-gradient-to-b from-white to-slate-50"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {" "}
          <div className="lg:text-center mb-16">
            <h2 className="text-base text-amber-600 font-semibold tracking-wide uppercase">
              Platform Features
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Enterprise-Grade PDF Generation at Scale
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
              From compliance reports to customer communications, our platform
              handles everything your organization needs to create professional
              documents efficiently and securely.
            </p>
          </div>
          <div className="mt-16">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
              {" "}
              {[
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                      />
                    </svg>
                  ),
                  title: "Universal Data Import",
                  description:
                    "Support for CSV, Excel (XLS/XLSX), JSON, and XML formats with intelligent schema detection. Handle complex nested data structures with automatic field mapping and validation.",
                  color: "from-slate-700 to-slate-800",
                },
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.5L15.232 5.232z"
                      />
                    </svg>
                  ),
                  title: "Visual Template Designer",
                  description:
                    "Powerful drag-and-drop editor with advanced layout controls, custom fonts, dynamic content regions, and conditional formatting. Build pixel-perfect templates without coding.",
                  color: "from-amber-500 to-amber-600",
                },
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                      />
                    </svg>
                  ),
                  title: "High-Performance Processing",
                  description:
                    "Generate thousands of documents in minutes with our distributed processing engine. Smart queue management and parallel processing ensure maximum throughput.",
                  color: "from-yellow-500 to-orange-600",
                },
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  ),
                  title: "Smart Preview System",
                  description:
                    "Real-time document preview with dynamic data binding. Test your templates with sample data before running full batch operations.",
                  color: "from-stone-600 to-stone-700",
                },
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                      />
                    </svg>
                  ),
                  title: "Enterprise Security",
                  description:
                    "SOC 2 Type II compliance, end-to-end encryption, GDPR/CCPA compliance, and comprehensive audit trails. Your data stays secure throughout the entire process.",
                  color: "from-amber-600 to-amber-700",
                },
                {
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                      />
                    </svg>
                  ),
                  title: "Multi-Organization Support",
                  description:
                    "Manage multiple organizations, departments, and teams with granular permissions, resource allocation, and usage tracking. Perfect for agencies and large enterprises.",
                  color: "from-slate-600 to-slate-700",
                },
              ].map((feature, index) => (
                <div
                  key={index}
                  className={`relative group bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-500 p-8 border border-stone-200 hover:border-transparent transform hover:-translate-y-2 ${
                    currentFeature === index
                      ? "ring-2 ring-amber-500 shadow-xl"
                      : ""
                  }`}
                >
                  <div
                    className={`inline-flex items-center justify-center p-3 bg-gradient-to-r ${feature.color} rounded-xl shadow-lg text-white group-hover:scale-110 transition-transform duration-300`}
                  >
                    {feature.icon}
                  </div>
                  <h3 className="mt-6 text-xl font-semibold text-gray-900 group-hover:text-amber-600 transition-colors duration-300">
                    {feature.title}
                  </h3>
                  <p className="mt-3 text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>{" "}
      {/* How It Works Section */}
      <div
        id="how-it-works"
        className="py-14 bg-gradient-to-br from-stone-50 via-white to-amber-50"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {" "}
          <div className="lg:text-center mb-16">
            <h2 className="text-base text-amber-600 font-semibold tracking-wide uppercase">
              How It Works
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              From Raw Data to Professional Documents in Minutes
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
              Our streamlined workflow transforms your business data into
              stunning, personalized documents faster than any traditional
              solution. No technical expertise required.
            </p>
          </div>
          <div className="relative">
            {/* Connecting lines */}
            <div className="hidden lg:block absolute top-1/2 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-indigo-200 via-purple-200 to-indigo-200 transform -translate-y-1/2"></div>

            <div className="grid grid-cols-1 gap-12 lg:grid-cols-3">
              {" "}
              {[
                {
                  step: "01",
                  title: "Import & Map Your Data",
                  description:
                    "Upload your data files in any format (CSV, Excel, JSON, XML). Our intelligent system automatically detects field types, suggests mappings, and validates data integrity. Handle complex datasets with nested structures, custom field transformations, and data cleansing rules.",
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                      />
                    </svg>
                  ),
                  color: "from-blue-500 to-indigo-600",
                },
                {
                  step: "02",
                  title: "Design Professional Templates",
                  description:
                    "Create stunning document layouts using our visual drag-and-drop editor. Add dynamic text fields, images, charts, tables, and conditional content blocks. Apply branding, custom fonts, and advanced formatting. Test with live data preview before finalizing your design.",
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.5L15.232 5.232z"
                      />
                    </svg>
                  ),
                  color: "from-purple-500 to-pink-600",
                },
                {
                  step: "03",
                  title: "Generate & Distribute at Scale",
                  description:
                    "Process thousands of personalized documents in minutes with our high-performance engine. Monitor generation progress in real-time, download individual files or bulk archives, and set up automated email distribution with custom delivery rules and tracking.",
                  icon: (
                    <svg
                      className="h-8 w-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                  ),
                  color: "from-green-500 to-teal-600",
                },
              ].map((step, index) => (
                <div
                  key={index}
                  className="relative flex flex-col items-center text-center group"
                >
                  {/* Step number */}
                  <div className="flex items-center justify-center w-16 h-16 mb-6 relative">
                    <div
                      className={`absolute inset-0 bg-gradient-to-r ${step.color} rounded-full opacity-20 group-hover:opacity-30 transition-opacity duration-300`}
                    ></div>
                    <div
                      className={`relative z-10 flex items-center justify-center w-12 h-12 bg-gradient-to-r ${step.color} rounded-full text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300`}
                    >
                      {step.step}
                    </div>
                  </div>

                  {/* Icon */}
                  <div
                    className={`inline-flex items-center justify-center p-3 bg-gradient-to-r ${step.color} rounded-xl shadow-lg text-white mb-6 group-hover:scale-110 transition-transform duration-300`}
                  >
                    {step.icon}
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 group-hover:text-indigo-600 transition-colors duration-300">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed max-w-sm">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>{" "}
        </div>
      </div>{" "}
      {/* CTA Section */}
      <div className="bg-gradient-to-r from-slate-800 via-stone-700 to-amber-700 relative overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="relative max-w-4xl mx-auto py-20 px-4 sm:px-6 sm:py-14 lg:max-w-7xl lg:px-8 lg:flex lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <h2 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
              Ready to Transform Your Document Workflow?
            </h2>
            <p className="mt-6 text-xl text-amber-100 max-w-3xl">
              Join 500+ enterprise customers who trust our platform to generate
              millions of professional documents every month. Start your free
              trial today—no credit card required, no setup fees, instant access
              to all enterprise features.
            </p>{" "}
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <div className="flex items-center text-amber-100">
                <svg
                  className="h-5 w-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>SOC 2 Compliant</span>
              </div>
              <div className="flex items-center text-amber-100">
                <svg
                  className="h-5 w-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>99.9% Uptime SLA</span>
              </div>
              <div className="flex items-center text-indigo-100">
                <svg
                  className="h-5 w-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>24/7 Support</span>
              </div>
            </div>
          </div>
          <div className="mt-10 w-full max-w-xs lg:mt-0 lg:flex-shrink-0">
            <div className="space-y-4">
              <Link
                to="/register"
                className="flex items-center justify-center bg-white bg-opacity-20 backdrop-blur-sm border-2 border-white border-opacity-30 px-8 py-4 text-base font-medium rounded-xl shadow-lg text-white hover:bg-opacity-30 transition-all duration-300 transform hover:scale-105"
              >
                Start Free Trial
                <svg
                  className="ml-2 h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </Link>
              <div className="text-center">
                <p className="text-sm text-amber-100">
                  No credit card required • Full enterprise features • Setup in
                  5 minutes
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      {/* Industry Use Cases Section */}
      <div id="industries" className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:text-center mb-16">
            <h2 className="text-base text-amber-600 font-semibold tracking-wide uppercase">
              Industry Applications
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Powering Document Workflows Across Industries
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
              From financial services to healthcare, our platform adapts to your
              industry's unique requirements with enterprise-grade security and
              compliance.
            </p>
          </div>{" "}
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 xl:grid-cols-3">
            {[
              {
                industry: "Financial Services",
                title: "Customer Statements & Reports",
                description:
                  "Generate personalized account statements, investment reports, and compliance documents with bank-level security and regulatory compliance.",
                icon: "💰",
                features: [
                  "SOC 2 Compliance",
                  "Encrypted Processing",
                  "Audit Trails",
                ],
              },
              {
                industry: "Healthcare",
                title: "Patient Communications",
                description:
                  "Create HIPAA-compliant patient letters, appointment confirmations, and medical reports with secure data handling and privacy protection.",
                icon: "🏥",
                features: [
                  "HIPAA Compliant",
                  "Data Encryption",
                  "Secure Storage",
                ],
              },
              {
                industry: "Education",
                title: "Certificates & Transcripts",
                description:
                  "Automate generation of student certificates, transcripts, and personalized communications with institutional branding and verification.",
                icon: "🎓",
                features: [
                  "Batch Processing",
                  "Digital Signatures",
                  "Brand Consistency",
                ],
              },
              {
                industry: "E-commerce",
                title: "Order Confirmations & Invoices",
                description:
                  "Streamline order processing with automated invoice generation, shipping labels, and personalized customer communications.",
                icon: "🛒",
                features: [
                  "API Integration",
                  "Real-time Processing",
                  "Multi-currency",
                ],
              },
              {
                industry: "Real Estate",
                title: "Property Documents & Contracts",
                description:
                  "Generate property reports, contracts, and client communications with legal compliance and professional presentation.",
                icon: "🏠",
                features: [
                  "Legal Templates",
                  "Digital Workflows",
                  "Client Portals",
                ],
              },
              {
                industry: "Insurance",
                title: "Policy Documents & Claims",
                description:
                  "Automate policy generation, claims processing, and customer notifications with regulatory compliance and security.",
                icon: "🛡️",
                features: [
                  "Regulatory Compliance",
                  "Automated Workflows",
                  "Secure Processing",
                ],
              },
            ].map((useCase, index) => (
              <div
                key={index}
                className="relative group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 hover:border-indigo-200 hover:shadow-xl transition-all duration-500"
              >
                <div className="flex items-center mb-4">
                  <span className="text-3xl mr-3">{useCase.icon}</span>
                  <div>
                    <p className="text-sm font-semibold text-amber-600 uppercase tracking-wide">
                      {useCase.industry}
                    </p>
                    <h3 className="text-xl font-bold text-gray-900">
                      {useCase.title}
                    </h3>
                  </div>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {useCase.description}
                </p>
                <div className="space-y-2">
                  {useCase.features.map((feature, fIndex) => (
                    <div
                      key={fIndex}
                      className="flex items-center text-sm text-gray-500"
                    >
                      <svg
                        className="h-4 w-4 text-green-500 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="mt-16 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-8 lg:p-12">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Enterprise Features Built for Scale
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-slate-800">SSO</div>
                  <div className="text-sm text-gray-600 mt-1">
                    Single Sign-On
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-purple-600">API</div>
                  <div className="text-sm text-gray-600 mt-1">
                    RESTful Integration
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">SLA</div>
                  <div className="text-sm text-gray-600 mt-1">99.9% Uptime</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-slate-800">24/7</div>
                  <div className="text-sm text-gray-600 mt-1">
                    Enterprise Support
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>{" "}
      {/* Connect with the Founder Section */}
      <div
        id="founder"
        className="py-14 bg-gradient-to-br from-white via-stone-50 to-amber-50 relative overflow-hidden"
      >
        {/* Background decoration */}
        <div className="absolute inset-0">
          <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-amber-100/40 to-stone-100/40 rounded-full translate-x-1/3 -translate-y-1/3"></div>
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-br from-slate-100/40 to-amber-100/40 rounded-full -translate-x-1/3 translate-y-1/3"></div>
        </div>

        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-6">
              Meet the Founder
            </h2>
            <p className="text-xl text-slate-600 leading-relaxed max-w-3xl mx-auto">
              Behind every great product is a passionate team. Learn about the
              vision driving Letterly and connect directly with our founder
              for enterprise partnerships, feedback, or just to say hello.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-stone-200">
            <div className="lg:flex">
              {/* Founder Image & Info */}
              <div className="lg:w-1/2 bg-gradient-to-br from-slate-700 to-amber-700 p-12 text-white relative">
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-amber-400/20 to-white/10 rounded-full -translate-y-16 translate-x-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-br from-white/10 to-amber-400/20 rounded-full -translate-x-12 translate-y-12"></div>

                <div className="relative z-10">
                  <div className="flex items-center mb-8">
                    <div className="w-24 h-24 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-4xl shadow-xl">
                      👨‍💻
                    </div>
                    <div className="ml-6">
                      <h3 className="text-3xl font-bold mb-2">Alex Johnson</h3>
                      <p className="text-amber-200 text-lg font-medium">
                        Founder & CEO
                      </p>
                      <div className="flex items-center mt-2">
                        <div className="w-3 h-3 bg-green-400 rounded-full mr-2 animate-pulse"></div>
                        <span className="text-sm text-amber-100">
                          Available for calls
                        </span>
                      </div>
                    </div>
                  </div>

                  <blockquote className="text-lg leading-relaxed mb-8">
                    "After years at Microsoft and Google, I saw how document
                    generation was still a pain point for businesses. PDF
                    Printer is my solution to make professional document
                    creation accessible to everyone."
                  </blockquote>

                  <div className="space-y-3">
                    <div className="flex items-center text-amber-100">
                      <svg
                        className="w-5 h-5 mr-3"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>8+ years in enterprise software</span>
                    </div>
                    <div className="flex items-center text-amber-100">
                      <svg
                        className="w-5 h-5 mr-3"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Former Microsoft & Google engineer</span>
                    </div>
                    <div className="flex items-center text-amber-100">
                      <svg
                        className="w-5 h-5 mr-3"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Passionate about solving real problems</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Options */}
              <div className="lg:w-1/2 p-12">
                <h4 className="text-2xl font-bold text-slate-900 mb-6">
                  Let's Connect
                </h4>
                <p className="text-slate-600 mb-8 leading-relaxed">
                  Whether you have questions about our platform, need enterprise
                  solutions, or want to share feedback, I'm always happy to
                  chat. Choose your preferred way to connect:
                </p>

                <div id="contact" className="space-y-4">
                  <a
                    href="mailto:alex@letterly.com"
                    className="flex items-center w-full p-4 bg-slate-50 hover:bg-slate-100 rounded-xl border border-slate-200 hover:border-amber-300 transition-all duration-300 group"
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-slate-600 to-slate-700 rounded-lg flex items-center justify-center text-white group-hover:scale-110 transition-transform">
                      <svg
                        className="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                      </svg>
                    </div>
                    <div className="ml-4 flex-1">
                      <h5 className="font-semibold text-slate-900">Email Me</h5>
                      <p className="text-sm text-slate-600">
                        alex@letterly.com
                      </p>
                    </div>
                    <svg
                      className="w-5 h-5 text-slate-400 group-hover:text-amber-600 transition-colors"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://linkedin.com/in/alexjohnson-letterly"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center w-full p-4 bg-slate-50 hover:bg-slate-100 rounded-xl border border-slate-200 hover:border-amber-300 transition-all duration-300 group"
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center text-white group-hover:scale-110 transition-transform">
                      <svg
                        className="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.338 16.338H13.67V12.16c0-.995-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 .774 18.2 0 17.668 0h.003z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <div className="ml-4 flex-1">
                      <h5 className="font-semibold text-slate-900">LinkedIn</h5>
                      <p className="text-sm text-slate-600">
                        Professional network
                      </p>
                    </div>
                    <svg
                      className="w-5 h-5 text-slate-400 group-hover:text-amber-600 transition-colors"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://calendly.com/alexjohnson-letterly/30min"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center w-full p-4 bg-gradient-to-r from-amber-50 to-amber-100 hover:from-amber-100 hover:to-amber-200 rounded-xl border border-amber-200 hover:border-amber-300 transition-all duration-300 group"
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-amber-600 to-amber-700 rounded-lg flex items-center justify-center text-white group-hover:scale-110 transition-transform">
                      <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div className="ml-4 flex-1">
                      <h5 className="font-semibold text-slate-900">
                        Schedule a Call
                      </h5>
                      <p className="text-sm text-slate-600">
                        30-minute video chat
                      </p>
                    </div>
                    <svg
                      className="w-5 h-5 text-amber-600 group-hover:text-amber-700 transition-colors"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </a>
                </div>

                <div className="mt-8 p-4 bg-amber-50 rounded-xl border border-amber-200">
                  <div className="flex items-center text-amber-800">
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <span className="text-sm font-medium">
                      I typically respond within 24 hours
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      {/* Footer */}
      <footer className="bg-slate-900">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="space-y-8 xl:col-span-1">
              <div className="flex items-center">
                <span className="text-3xl">📄</span>
                <h2 className="ml-2 text-2xl font-bold text-white">
                  Letterly
                </h2>
              </div>
              <p className="text-stone-400 text-base max-w-md">
                The enterprise PDF generation platform trusted by 500+
                organizations worldwide. Transform your data into professional
                documents with enterprise-grade security, unlimited scalability,
                and 24/7 support.
              </p>
              <div className="flex space-x-6">
                <a
                  href="https://twitter.com/letterly"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-stone-400 hover:text-amber-400 transition-colors duration-300"
                >
                  <span className="sr-only">Twitter</span>
                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </a>
                <a
                  href="https://linkedin.com/company/letterly"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-stone-400 hover:text-amber-400 transition-colors duration-300"
                >
                  <span className="sr-only">LinkedIn</span>
                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
                <a
                  href="https://github.com/letterly"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-stone-400 hover:text-amber-400 transition-colors duration-300"
                >
                  <span className="sr-only">GitHub</span>
                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                  </svg>
                </a>
              </div>
            </div>
            <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
              <div className="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3 className="text-sm font-semibold text-stone-400 tracking-wider uppercase">
                    Navigation
                  </h3>
                  <ul className="mt-4 space-y-4">
                    <li>
                      <a
                        href="#features"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Features
                      </a>
                    </li>
                    <li>
                      <a
                        href="#how-it-works"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        How It Works
                      </a>
                    </li>
                    <li>
                      <a
                        href="#industries"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Industries
                      </a>
                    </li>
                    <li>
                      <a
                        href="#founder"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        About
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="mt-12 md:mt-0">
                  <h3 className="text-sm font-semibold text-stone-400 tracking-wider uppercase">
                    Support
                  </h3>
                  <ul className="mt-4 space-y-4">
                    <li>                      <a
                        href="mailto:support@letterly.com"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Help Center
                      </a>
                    </li>
                    <li>
                      <a
                        href="/docs"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        API Documentation
                      </a>
                    </li>
                    <li>                      <a
                        href="mailto:support@letterly.com"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Contact Support
                      </a>
                    </li>
                    <li>
                      <a
                        href="/status"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        System Status
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3 className="text-sm font-semibold text-stone-400 tracking-wider uppercase">
                    Company
                  </h3>
                  <ul className="mt-4 space-y-4">
                    <li>
                      <a
                        href="#founder"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        href="/blog"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Blog
                      </a>
                    </li>
                    <li>
                      <a
                        href="/careers"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Careers
                      </a>
                    </li>
                    <li>
                      <a
                        href="/press"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Press
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="mt-12 md:mt-0">
                  <h3 className="text-sm font-semibold text-stone-400 tracking-wider uppercase">
                    Legal
                  </h3>
                  <ul className="mt-4 space-y-4">
                    <li>
                      <a
                        href="/privacy"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="/terms"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Terms of Service
                      </a>
                    </li>
                    <li>
                      <a
                        href="/cookies"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        Cookie Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="/gdpr"
                        className="text-base text-stone-300 hover:text-amber-400 transition-colors duration-300"
                      >
                        GDPR
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 border-t border-slate-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-base text-stone-400">
                &copy; 2025 Letterly. All rights reserved.
              </p>
              <p className="text-sm text-stone-500 mt-4 md:mt-0">
                Powered by Opalina
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
